import { apiClient } from './axiosInstance';
import { IUpdateTimeOffRequestData } from '../features/timeOffRequestInfo/timeOffRequestInfoTypes';

export const fetchTimeOffRequestInfo = async (requestId: number) => {
  return await apiClient.get(`/time-off/requests/${requestId}`);
};

export const updateTimeOffRequestInfo = async (
  data: IUpdateTimeOffRequestData
) => {
  return await apiClient.patch(`/time-off/requests/${data.id}`, {
    ...data,
  });
};
